export default {
    title: "資料修改",
    form1: "登錄名",
    form2: "原密碼",
    form3: "新密碼",
    form4: "確認密碼",
    rule1: "原密碼不能為空！",
    rule2: "新密碼不能為空！",
    rule3: "確認密碼不能為空！",
    rule4: "與新密碼不一致，請重新輸入",
    errmsg: "原密碼有誤，請重新輸入！"
}